export default {
  SET_TESTIMONIAL(state, payload) {
    state.testimonial = payload;
  },
};
